import { render, staticRenderFns } from "./ItemsTable.vue?vue&type=template&id=12f1d54b&scoped=true"
import script from "./ItemsTable.vue?vue&type=script&lang=js"
export * from "./ItemsTable.vue?vue&type=script&lang=js"
import style0 from "./ItemsTable.vue?vue&type=style&index=0&id=12f1d54b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f1d54b",
  null
  
)

export default component.exports